import React, { useState, useRef } from 'react';
import './actionIconButton.css';

const ActionIconButton = ({ icon, tooltip, onClick, as: Tag, to, className }) => {
  const [tooltipStyle, setTooltipStyle] = useState(null);
  const btnRef = useRef(null);

  const handleMouseEnter = () => {
    const rect = btnRef.current.getBoundingClientRect();
    setTooltipStyle({
      top: rect.top + rect.height / 2,
      left: rect.left + rect.width / 2,
    });
  };

  const handleMouseLeave = () => {
    setTooltipStyle(null);
  };

  const commonProps = {
    ref: btnRef,
    className: `action-icon-btn ${className || ''}`,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    onClick,
  };

  if (Tag) {
    commonProps.to = to;
  } else {
    commonProps.type = 'button';
  }

  const Element = Tag || 'button';

  return (
    <>
      <Element {...commonProps}>
        {icon}
      </Element>
      {tooltipStyle && (
        <div
          className="action-icon-tooltip"
          style={{ top: tooltipStyle.top, left: tooltipStyle.left }}
        >
          {tooltip}
        </div>
      )}
    </>
  );
};

export default ActionIconButton;
